import axiosRatingEngine from '@/services/axiosRatingEngine'

export default {
  computed: {
    slides: {
      get () {
        return this.$store.getters.getSlides
      },
      set (value) {
        this.$store.commit(`updateSlides`, value)
      },
    },
    backgroundImage: {
      get () {
        return this.$store.getters.getSlidesBackground
      },
      set (value) {
        this.$store.commit(`updateSlidesBackground`, value)
      },
    },
  },
  methods: {
    async getSlides (key) {
      await axiosRatingEngine
        .post('api/products/slides', {
          rate: `${key}`,
          industryId: this.$store.getters.getIndustryId,
          turnover: this.$store.getters.getTurnover,
          employeeCount: this.$store.getters.getEmployeeCount,
          isValidBusiness: this.$store.getters.getIsValidBusiness,
        })
        .then((response) => {
          const responseSlides = []
          if (response.data.slide_1) {
            responseSlides.push(response.data.slide_1)
            if (response.data.slide_2) responseSlides.push(response.data.slide_2)
            if (response.data.slide_3) responseSlides.push(response.data.slide_3)
            if (response.data.background_image) {
              this.backgroundImage = response.data.background_image
            }
            this.slides = responseSlides
            this.$router.push(`/products/${key}/info`)
          } else {
            this.$router.push(`/products/${key}/config`)
          }
        })
        .catch(() => {
          this.$router.push(`/products/${key}/config`)
        })
    },
  },
}
